import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, CurrencyPipe } from '@angular/common';
import * as moment from 'moment';
import { InvoiceStatePipe } from './invoice-state.pipe';

@Pipe({
  name: 'formatData'
})
export class FormatDataPipe implements PipeTransform {

  constructor(private datePipe: DatePipe, private currencyPipe: CurrencyPipe, private invoiceStatePipe: InvoiceStatePipe) {
  }

  transform(value: unknown, ...args: unknown[]): unknown {
    switch (typeof value) {
      case 'boolean':
        return value ? 'Oui' : 'Non';
      case 'number':
        return this.transformNumber(value, args);
      case 'string':
        if (args && args.includes('State'))
          return this.invoiceStatePipe.transform(value);
        if (moment(value, moment.ISO_8601).isValid() && value.indexOf('T') == 10)
          return this.transformDate(value, args);
        return value;
      case 'object':
        return this.transformObject(value, args);
      default:
        return value;
    }
  }
  transformObject(value: object, args: unknown[]): unknown {
    if (args && args.includes('SupervisionGroups')) {
      const items = Object.values(value).slice(0, 2).map(x => x.Name).join(', ');
      const itemsLength = Object.values(value).length;
      return itemsLength > 2 ? `${items}, +${itemsLength - 2} autres groupes` : items;
    }

    if (Object.prototype.toString.call(value) === '[object Date]')
      return this.transformDate(value.toString(), args);

    return value;
  }

  transformDate(value: string, args: unknown[]): unknown {
    if (args && args.includes('ImportDate'))
      return this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss');
    return this.datePipe.transform(value, 'dd/MM/yyyy');
  }

  transformNumber(value: number, args: unknown[]): unknown {
    if (args && (args.includes('Delay'))) {
      return `${value} jour${value > 1 ? 's' : ''}`;
    }
    if (args && (args.includes('InvoicesCount') || args.includes('FilesCount') || args.includes('Errors'))) {
      return value;
    }
    return this.currencyPipe.transform(value, 'EUR');
  }
}
